module.exports = "pegasus/assets/background-patterns/default-theme.jpg";